import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { Container, Stack, Typography } from "@mui/material";
import AppUserSearchTable from "src/components/users/AppUserSearchTable";

export default function UsersPage() {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Users | DreamTeam Admin</title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack spacing={3}>
          <Typography variant="h4">Users</Typography>
          <AppUserSearchTable
            actionLabel="Open"
            onSelectUser={(row) => navigate(`/dashboard/users/${row.id}`)}
          />
        </Stack>
      </Container>
    </>
  );
}
